import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import chosen from 'components/common/hoc/chosen'
import { getCategories, getServicesPickerItems } from './helpers'
import { setServicesList, setQuoteProductAndServices } from '../actions'
import { getValues as getFormValues } from 'components/Appointment/selectors'
import { withTabBehavior } from 'components/common/Tabs'
import BOTServicesSelector from './BOTServicesSelector'

const mapStateToProps = (state, { services: { servicesCategory }}) => {
  const { catalogRefIds: selectedServices } = getFormValues(state) || {}

  return {
    menu: getCategories({ selectedServices, servicesCategory }),
    servicesPickerItems: getServicesPickerItems({ servicesCategory })
  }
}

const withLifecycle = lifecycle({
  componentDidMount() {
    const {
      services: { servicesCategory },
      setServicesList,
      setQuoteProductAndServices
    } = this.props

    setQuoteProductAndServices()
    setServicesList(servicesCategory)
  }
})

export default compose(
  withType({ type: 'BOTServicesSelector' }),
  chosen(),
  connect(mapStateToProps, { setServicesList, setQuoteProductAndServices }),
  withTabBehavior,
  withLifecycle
)(BOTServicesSelector)
